// Job Service - Orchestrator that delegates to focused modules
import * as jobApi from './api/jobApi';
import { validateJobData } from './validation/jobValidation';
import { formatJobForDisplay, formatStatus, formatServiceType, getStatusColor } from './formatting/jobFormatter';
import { getFileIcon, formatFileSize } from './formatting/fileFormatter';
import { sortJobs, filterJobs } from './operations/jobFilters';
import { getJobStats } from './operations/jobStats';
import { exportToCSV, downloadCSV } from './operations/jobExport';
import { isJobOverdue, isJobDueToday } from './utils/jobHelpers';

class JobService {
  // API Operations
  async getJobs(franchiseeId, options = {}) {
    return jobApi.getJobs(franchiseeId, options);
  }

  async getJob(franchiseeId, jobId) {
    return jobApi.getJob(franchiseeId, jobId);
  }

  async createJob(franchiseeId, jobData) {
    return jobApi.createJob(franchiseeId, jobData);
  }

  async updateJob(franchiseeId, jobId, jobData) {
    return jobApi.updateJob(franchiseeId, jobId, jobData);
  }

  async deleteJob(franchiseeId, jobId) {
    return jobApi.deleteJob(franchiseeId, jobId);
  }

  async uploadAttachments(franchiseeId, jobId, files) {
    return jobApi.uploadAttachments(franchiseeId, jobId, files);
  }

  async getJobDocuments(franchiseeId, jobId) {
    return jobApi.getJobDocuments(franchiseeId, jobId);
  }

  // Validation
  validateJobData(jobData, isUpdate = false) {
    return validateJobData(jobData, isUpdate);
  }

  // Formatting & Display
  formatJobForDisplay(job) {
    return formatJobForDisplay(job);
  }

  formatStatus(status) {
    return formatStatus(status);
  }

  formatServiceType(serviceType) {
    return formatServiceType(serviceType);
  }

  getStatusColor(status) {
    return getStatusColor(status);
  }

  // File Operations
  getFileIcon(mimeType) {
    return getFileIcon(mimeType);
  }

  formatFileSize(bytes) {
    return formatFileSize(bytes);
  }

  // Business Logic Checks
  isJobOverdue(job) {
    return isJobOverdue(job);
  }

  isJobDueToday(job) {
    return isJobDueToday(job);
  }

  // Data Processing
  sortJobs(jobs, sortBy = 'scheduled_date', sortOrder = 'asc') {
    return sortJobs(jobs, sortBy, sortOrder);
  }

  filterJobs(jobs, searchTerm) {
    return filterJobs(jobs, searchTerm);
  }

  // Statistics
  getJobStats(jobs) {
    return getJobStats(jobs);
  }

  // Export Operations
  exportToCSV(jobs) {
    return exportToCSV(jobs);
  }

  downloadCSV(jobs, filename = 'jobs.csv') {
    return downloadCSV(jobs, filename);
  }
}

// Create singleton instance
const jobService = new JobService();

export default jobService;